export const editorConstants = {
  MAX_CHAR_LIMIT: 32767,
};